/**
 * Configuração compartilhada do OAuth do Mercado Livre.
 *
 * Por que este arquivo existe:
 * - `VITE_*` são variáveis de BUILD do Vite. Elas vêm do `.env.local` na sua
 *   máquina, mas o `.env.local` está no .gitignore — ou seja, NUNCA chega ao
 *   GitHub nem ao build do Cloudflare Pages. Em produção elas ficavam
 *   `undefined`, e o botão "Conectar" montava uma URL com
 *   `client_id=undefined&redirect_uri=undefined` → erro imediato no ML.
 * - A redirect_uri agora é derivada da origem atual (localhost em dev,
 *   mynd-bpo.pages.dev em produção), garantindo que autorização e troca do
 *   code usem SEMPRE o mesmo valor. A env `VITE_ML_REDIRECT_URI`, se definida,
 *   tem prioridade (útil para testar via ngrok).
 *
 * IMPORTANTE: cada redirect_uri usada precisa estar cadastrada no Dev Center
 * do ML (pode cadastrar mais de uma). O client_id não é segredo — ele aparece
 * na URL de autorização e já consta no .env.example do repositório.
 */

const FALLBACK_ML_CLIENT_ID = '7238658116989270';

export const ML_CLIENT_ID: string =
  (import.meta.env.VITE_ML_CLIENT_ID as string | undefined)?.trim() || FALLBACK_ML_CLIENT_ID;

export function getMlRedirectUri(): string {
  const fromEnv = (import.meta.env.VITE_ML_REDIRECT_URI as string | undefined)?.trim();
  if (fromEnv) return fromEnv;
  return `${window.location.origin}/api/ml/callback`;
}
